import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { ShopInfoState } from '../store/shop-info/shop-info.state';
import { SharedModule } from './../shared/shared.module';
import { FooterShellComponent } from './footer-shell.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [
    FooterComponent,
    FooterShellComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule.forChild(),
    NgxsModule.forFeature([
      ShopInfoState
    ])
  ],
  exports: [FooterShellComponent]
})
export class FooterShellModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: FooterShellModule
    };
  }
}
